var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_97_14595)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.69683 9.42468L6.22217 9.77868L6.5755 7.30334L12.9395 0.939343C13.2208 0.658036 13.6023 0.5 14.0002 0.5C14.1972 0.5 14.3922 0.538799 14.5742 0.614181C14.7562 0.689564 14.9215 0.800054 15.0608 0.939343C15.2001 1.07863 15.3106 1.24399 15.386 1.42598C15.4614 1.60797 15.5002 1.80303 15.5002 2.00001C15.5002 2.19699 15.4614 2.39205 15.386 2.57404C15.3106 2.75603 15.2001 2.92139 15.0608 3.06068L8.69683 9.42468Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2319 1.64648L14.3533 3.76782",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 9.5V14.5C12.5 14.7652 12.3946 15.0196 12.2071 15.2071C12.0196 15.3946 11.7652 15.5 11.5 15.5H1.5C1.23478 15.5 0.98043 15.3946 0.792893 15.2071C0.605357 15.0196 0.5 14.7652 0.5 14.5V4.5C0.5 4.23478 0.605357 3.98043 0.792893 3.79289C0.98043 3.60536 1.23478 3.5 1.5 3.5H6.5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_97_14595"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.9153ba3a5e4ac1a116d809003f6f62d1.svg";
export { ForwardRef as ReactComponent };